<template>
	<div>
		<div class="hero">
			<div class="content">
				<h1 v-html="$t('publicTraining.heroSection.title')"></h1>
				<p v-html="$t('publicTraining.heroSection.description')"></p>
				<div class="btn-cta">
					<button class="now" @click="scrollToSection('public-training-class')">
						{{ $t('publicTraining.heroSection.ctaButtons.viewClasses') }}
					</button>
					<button class="call" @click="sendToWa">
						{{ $t('publicTraining.heroSection.ctaButtons.consultationFirst') }}
					</button>
				</div>
			</div>
			<div class="card-img">
				<img src="/img/publictraining/hero.png" width="556" height="392" alt="public-training-hero" />
			</div>
		</div>

		<div class="benefits text-center container">
			<h3 class="sub-title-span">
				{{ $t('publicTraining.benefitsSection.title') }}
			</h3>
			<div class="card-benefits">
				<div v-for="n in $t('publicTraining.benefitsSection.benefits')" :key="n.id"
					class="content-card mr-2 ml-2">
					<div class="left-span">
						<img :src="n.image" width="80" height="80" style="border-radius: 50%" />
					</div>
					<div>
						<div class="title-2" style="text-align: left">{{ n.title }}</div>
						<div class="desc mt-2" style="text-align: left">{{ n.desc }}</div>
					</div>
				</div>
			</div>
		</div>

		<div id="public-training-class" class="text-center container" style="margin-top: 104px">
			<h3 class="sub-title-span">
				{{ $t('publicTraining.categorySection.title') }}
			</h3>
			<div class="d-flex container justify-center category-class" style="margin-top: 48px">
				<div v-for="(data, idx) in $t('publicTraining.categorySection.actionMethod')" :key="idx"
					class="inactive category-class-card" :class="{ active: layout == data.slug_name }"
					@click="changeCategory(data.slug_name, data.title)">
					<img :src="data.icon" alt="category-class-icon" width="56" height="56" />
					<div class="category-class-detail">
						<div class="category-class-info">
							<h4>{{ data.title }}</h4>
							<p>{{ data.desc }}</p>
						</div>
						<Arrow :width="32" :height="32" direct="right" />
					</div>
				</div>
			</div>
		</div>

		<div class="text-center container" style="margin-top: 104px">
			<h3 class="sub-title-span">
				{{ $t('publicTraining.recommendationSection.title') }}
			</h3>
			<div v-if="classRecommends.length > 0">
				<div class="class-list-container mx">
					<CardClass v-for="n in classRecommends" :key="n.id" :onClick="handleCardClick" :data="n" />
				</div>
			</div>
			<div v-else>
				<div class="text-center" style="margin: 20px 0">
					<img src="/img/other/ic_coming_soon.png" height="300" />
					<p>{{ $t('publicTraining.recommendationSection.emptyMessage') }}</p>
				</div>
			</div>
		</div>

		<div class="text-center explore-class-container" style="margin-top: 104px">
			<h3 class="sub-title-span" style="margin-bottom: 48px">
				{{ $t('publicTraining.exploreSection.title') }}
			</h3>
			<div v-for="(i, idx) in subCategories" :key="i.name" class="container-sub-category">
				<hr size="2" color="#ACAFBF" style="margin-bottom: 64px; margin-top: 64px" v-if="!idx == 0" />
				<h4 class="title-sub-category" v-if="i.name">
					{{ i.name }}
				</h4>
				<div class="class-list-container">
					<CardClass v-for="n in i.recommendationClass" :key="n.id" :onClick="handleCardClick" :data="n" />
				</div>
				<div v-if="!i.recommendationClass.length">
					<div class="text-center" style="margin: 20px 0">
						<img src="/img/other/ic_coming_soon.png" height="300" />
					</div>
				</div>
			</div>
		</div>

		<div class="faq">
			<div class="content">
				<div class="row">
					<div class="xai-col-lg-3">
						<div class="header" style="margin-bottom: 20px">
							<h1>Frequently Asked Question</h1>
						</div>
					</div>
					<div class="xai-col-lg-9" style="margin-top: -10px">
						<v-expansion-panels flat class="faq-card" style="padding: 20px">
							<v-expansion-panel v-for="(item, index) in questions" :key="index" style="
									border-radius: 20px;
									padding: 0;
									margin-bottom: 10px;
									background-color: #f7f9fd;
								">
								<v-expansion-panel-header disable-icon-rotate @click="openFaq(index)">
									<h2 style="margin: 25px 0; font-size: 18px; line-height: 24px;">
										{{ item.title }}
									</h2>
									<template v-slot:actions>
										<div class="icon">
											<Arrow :down="!item.active" />
										</div>
									</template>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<div v-html="item.description" style="width: 95%"></div>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
						<div class="btn-stoke-gray cursor-pointer" @click="goToFaqPage">
							<span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
							<ArrowLong fill="#575966" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Arrow from '@/assets/icons/Arrow2.vue';
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import CardClass from './CardClass.vue';

export default {
	components: {
		Arrow,
		ArrowLong,
		CardClass,
	},
	data() {
		return {
			layout: 'teknologi',
			categoryList: [
				{
					id: 1,
					name: "teknologi"
				},
				{
					id: 2,
					name: "bahasa"
				},
				{
					id: 3,
					name: "soft-skill"
				},
			],
			subCategories: [],
			classRecommends: [],
			questions: [],
		};
	},
	watch: {
		"$i18n.locale"() {
			this.onEmptyData();
			this.getDataClassRecomendation();
			this.getDataClass();
			this.getFaq();
		},
	},
	methods: {
		changeCategory(categoryId, categoryTitle) {
			this.$gtag.event('click', {
				event_category: 'Navigation',
				event_label: `Select Category - ${categoryTitle} - Public Training Page`,
				value: 1,
			});
			this.$router.push(`/class/public-training/${categoryId}`);
			window.location.reload();
		},
		async getDataClassRecomendation() {
			try {
				const response = await this.$http.get(`/v1/class?is_recommend=true`);
				this.classRecommends = response.data.data.classes;
			} catch (err) {
				console.error(err.response);
			}
		},
		async getDataClass() {
			this.onEmptyData();
			const categoryId = this.categoryList.find((item) => item.name === this.layout);
			try {
				const response = await this.$http.get(`/v1/class/category/${categoryId.id}`);
				response.data.data.classes.forEach((element) => {
					if (this.layout == 'teknologi') {
						if (element.class_sub_category.id == 1) {
							this.subCategories[0].recommendationClass.push({
								id: parseInt(element.id),
								name: element.name,
								thumbnail_url: element.thumbnail_url,
								description: element.description,
								level: element.level,
								method: element.method,
								slug_name: element.slug_name,
								session: element.session,
								days: element.days,
								hours: element.hours,
							});
						} else if (element.class_sub_category.id == 2) {
							this.subCategories[1].recommendationClass.push({
								id: parseInt(element.id),
								name: element.name,
								thumbnail_url: element.thumbnail_url,
								description: element.description,
								level: element.level,
								method: element.method,
								slug_name: element.slug_name,
								session: element.session,
								days: element.days,
								hours: element.hours,
							});
						} else {
							this.subCategories[2].recommendationClass.push({
								id: parseInt(element.id),
								name: element.name,
								thumbnail_url: element.thumbnail_url,
								description: element.description,
								level: element.level,
								method: element.method,
								slug_name: element.slug_name,
								session: element.session,
								days: element.days,
								hours: element.hours,
							});
						}
					} else {
						this.subCategories[0].recommendationClass.push({
							id: parseInt(element.id),
							name: element.name,
							thumbnail_url: element.thumbnail_url,
							description: element.description,
							level: element.level,
							method: element.method,
							slug_name: element.slug_name,
							session: element.session,
							days: element.days,
							hours: element.hours,
						});
					}
				});
			} catch (err) {
				console.error(err.response);
			}
		},
		handleCardClick(slugName, className) {
			this.$gtag.event('click', {
				event_category: 'Navigation',
				event_label: `Class Card Click - ${className} - Public Training Page`,
				value: 1,
			});
			this.$router.push('/class/public-training/detail/' + slugName);
		},
		sendToWa() {
			this.$gtag.event('click', {
				event_category: 'Navigation',
				event_label: 'Free Consultation WhatsApp - Public Training Page',
				value: 1,
			});
			window.open(
				'https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya',
				'_blank'
			);
		},
		scrollToSection(sectionId) {
			this.$gtag.event('click', {
				event_category: 'Navigation',
				event_label: 'View Classes - Public Training Page',
				value: 1,
			});
			const element = document.getElementById(sectionId);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' });
			}
		},
		onEmptyData() {
			if (this.layout == 'teknologi') {
				this.subCategories = [
					{
						name: 'Kelas Programming',
						recommendationClass: [],
					},
					{
						name: 'Kelas Data',
						recommendationClass: [],
					},
					{
						name: 'Kelas Desain',
						recommendationClass: [],
					},
				];
			} else {
				this.subCategories = [
					{
						name: '',
						recommendationClass: [],
					},
				];
			}
		},
		async getFaq() {
			this.questions = [];
			try {
				const resp = await this.$http.get(`/v1/faq?category=PUBLIC_TRAINING&is_main=true`);
				this.questions = resp.data.data.faq.map((item) => ({
					description: item.answer[0],
					title: item.question,
					active: false
				}));
			} catch (err) {
				this.isErr = true;
				this.errMessage = err.response.data.data;
			}
		},
		openFaq(idx) {
			const valDef = this.questions[idx].active;
			this.questions.forEach((e) => {
				e.active = false;
			});
			this.questions[idx].active = !valDef;
			this.$gtag.event('click', {
				event_category: 'Interaction',
				event_label: `Toggle FAQ - ${this.questions[idx].title} - Public Training Page`,
				value: 1,
			});
		},
		goToFaqPage() {
			this.$gtag.event('click', {
				event_category: 'Navigation',
				event_label: 'View More FAQs - Public Training Page',
				value: 1,
			});
			this.$router.push('/faq');
		},
	},
	mounted() {
		this.layout = this.$route.params.category ?? 'teknologi';
		this.getFaq();
		this.getDataClass();
		this.getDataClassRecomendation();
		this.$gtag.pageview(this.$route);
	},
};
</script>

<style src="./css/publicTraining.css" scoped></style>